module.exports = __webpack_public_path__ + "img/kv_pc_n1.70ebce9e.png";